var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.variant)?_c('div',{staticClass:"flex"},_vm._l((_vm.variant),function(item,vIndex){return _c('div',{key:vIndex,staticClass:"flex max-w-sm text-xs"},[_c('w-item-variant-line',{attrs:{"item":item}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }